import Exercise from '@/api/exercise';
import { isEmpty, isNil } from 'lodash';
import { safeLock } from '../common/util';

export async function createExercise(data: { [key: string]: string }) {
  let exercise: Exercise = null;

  if (isEmpty(data['exercise_id'])) {
    exercise = new Exercise(data['game_type']);
    exercise.parent_lesson = Number.parseInt(data['lesson_id']);
  } else {
    exercise = await Exercise.get(Number.parseInt(data['exercise_id']));
  }

  exercise.order = Number.parseInt(data['order']);
  exercise.intelligibility_ready = data['intelligibility_ready'] === 'TRUE';

  if (exercise.id) {
    await safeLock(Exercise.SLUG, exercise.id, () => exercise.save());
  } else {
    await exercise.save();
  }

  return exercise;
}

export async function cleanupExerciseContent(exercise: Exercise) {
  if (!isNil(exercise.speaking_content)) {
    for (const item of exercise.speaking_content.phoneme_objects) {
      await item.delete();
    }

    for (const item of exercise.speaking_content.stress_marker_objects) {
      await item.delete();
    }
  }
}
